<template>
  <v-form ref="ChangePriceEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'change-price-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование графика изменения цен' : 'Создание графика изменения цен'}}</h1>
      </v-col>
      <v-col  cols="12" sm="5" md="7" xl="5">
        <v-text-field
            v-model="changePrice.change_at"
            label="Дата обновления цены"
            v-mask="'####-##-## ##:##'"
            outlined
            hide-details
        ></v-text-field>
        <v-autocomplete
            class="mt-4"
            v-model="changePrice.products"
            :items="products"
            :loading="isLoadingAutocomplete"
            multiple
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="id"
            label="Блюдо"
            outlined
            return-object
        ></v-autocomplete>


        <v-data-table
            no-data-text="Нет ингредиентов"
            no-results-text="По заданному запросу ничего не найдено"
            :headers="headers"
            :header-props="{sortIcon: 'icon-custom-arrow'}"
            :items="changePrice.products"
            loading-text="Загрузка... Подождите пожалуйста"
        >
          <template v-slot:item.change_price="{ item }">
            <v-text-field hide-details outlined v-model="item.change_price" dense suffix="UAH"></v-text-field>
          </template>
        </v-data-table>

        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import CategoryService from "../../api/CategoryService";
  import ChangePriceService from "@/api/ChangePriceService";
  import ProductService from "@/api/ProductService";

  export default {
    name: 'ChangePriceEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      headers: [
        {
          text: 'Название',
          value: 'name',
          sortable: false
        },
        {
          text: 'Цена',
          value: 'change_price',
        },
      ],
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      search: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      changePrice: {
        product_id: null,
        change_at: '',
        price: '',
      },
      loading: true,
      isLoadingAutocomplete: false,
      loadingButton: false,
      products: [],
    }),
    mounted() {
        if(this.id) {
            ChangePriceService.get(this.id)
                .then(response => {
                    this.changePrice = response.data;
                    this.loading = false
                });
        }
    },
    watch: {
      search (val) {
        if (this.isLoadingAutocomplete) return

        this.isLoadingAutocomplete = true

        // Lazily load input items
        ProductService.findByName({word: this.search}).then(response => {
          this.products = response.data;
        }).finally(response => {
          this.isLoadingAutocomplete = false
        });
      },
    },
    methods: {
      validate() {
        this.$refs.ChangePriceEditForm.validate()
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        ChangePriceService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        ChangePriceService.create(formData).then(response => {
            this.$router.push({ name: 'change-price-edit', params: { id: response.data.id } })
          this.changePrice.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();
          const productIds = this.changePrice.products.map((val) => {
            formData.append('products['+val.id+']', val.change_price);
          })

          formData.append('id', this.id);
          formData.append('change_at', this.changePrice.change_at);

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
